import { stepinAuthInstance } from '@/apis/types/stepinAuth';

const { GET, POST, DELETE } = stepinAuthInstance;

export interface sendEmailProps {
	email: string;
	hl?: string;
}

export interface VerifyEmailBody {
	token: string;
	code: string;
}

export interface SignupEmailBody {
	email: string;
	password: string;
	marketingTerms: boolean;
}

export interface SigninEmailBody {
	email: string;
	password: string;
}

export const sendEmail = async ({ email, hl = 'ko' }: sendEmailProps) => {
	return POST('/auth/email/send', {
		body: {
			email,
			hl: hl,
			// @ts-ignore
			type: 'EMAIL_VERIFY',
		},
	});
};

export const verifyEmail = async ({ token, code }: VerifyEmailBody) => {
	return POST('/auth/email/verify', {
		body: {
			code: code,
			token: token,
		},
	});
};

export const signupEmail = async ({ email, password, marketingTerms }: SignupEmailBody) => {
	return POST('/auth/signup/email', {
		body: {
			email: email,
			marketingTerms: marketingTerms,
			password: password,
		},
	});
};

export const signinEmail = async ({ email, password }: SigninEmailBody) => {
	return POST('/auth/signin/web/email', {
		body: {
			email,
			password,
		},
	});
};

export const signinEamilForMobile = async ({ email, password }: SigninEmailBody) => {
	return POST('/auth/signin/email', {
		body: {
			email,
			password,
		},
	});
};

export const getLinkedBusinessAccountList = async () => {
	return GET('/user/business/list');
};

export const mobileLogin = async (token: string) => {
	const { data, response } = await POST('/auth/switch/web', {
		body: { accessToken: token },
	});

	if (data && data.data) {
		// 원본 로직과 동일하게 처리
		return {
			data: data.data,
			response,
		};
	}
	throw new Error('로그인 실패');
};

export const deleteAdmin = (userId: string) => {
	return DELETE('/auth/business/admin/{userId}', {
		params: {
			path: {
				userId,
			},
		},
	});
};

export const grantOwner = (userId: string) => {
	return POST('/auth/business/owner', {
		body: {
			userId,
		},
	});
};
